import { SystemStyleObject } from '@chakra-ui/react';

/**
 * Custom styling for disabled input fields to make them more visually distinct
 * Uses dark gray colors to clearly indicate disabled state
 */
export const disabledInputStyles: SystemStyleObject = {
  _disabled: {
    backgroundColor: 'gray.200',
    borderColor: 'gray.300',
    color: 'gray.600',
    opacity: 1,
    cursor: 'not-allowed',
  },
};

/**
 * Custom styling for disabled textarea fields
 */
export const disabledTextareaStyles: SystemStyleObject = {
  ...disabledInputStyles,
};

/**
 * Custom styling for disabled date input fields
 */
export const disabledDateInputStyles: SystemStyleObject = {
  _disabled: {
    backgroundColor: 'gray.200',
    borderColor: 'gray.300',
    color: 'gray.600',
    opacity: 1,
    cursor: 'not-allowed',
    // Date inputs sometimes need special handling
    WebkitTextFillColor: 'var(--chakra-colors-gray-600)',
  },
};
